module.exports = __webpack_public_path__ + "static/media/paintrMain.12381423.png";